//
// Winline Manager

winlineManager = {};
winlineManager.winlineData = function (json, parentName) {
  this.id = json.id;
  this.colour = json.colour;
  this.fillColour =
    json.fillColour !== undefined ? json.fillColour : json.colour;

  if (json.pipData !== undefined) {
    this.pipBorderColour = json.pipData.borderColour;
    this.pipBorderSize = json.pipData.borderSize;
    this.pipFileName = json.pipData.fileName;
    this.pipSize = json.pipData.pipSize;
    this.pipFont = json.pipData.font;
    this.pipPositions = { left: json.pipData.left, right: json.pipData.right };
  } else {
    this.pipBorderColour =
      this.pipBorderSize =
      this.pipFileName =
      this.pipSize =
      this.pipFont =
        undefined;
    this.pipPositions = { left: undefined, right: undefined };
  }

  this.winlineContainer = resourceManager.createObject(
    "container",
    "winline" + this.id + "Container",
    parentName,
    {}
  );
  this.winlinePipGraphics = [];
  this.winlinePipNumbers = [];
  this.winLineGraphics = resourceManager.createObject(
    "container",
    "graphics",
    this.winlineContainer.name,
    {}
  );
  this.lineData = [];
  this.currentPreviewTime = 0.0;
};

winlineManager.create = function () {
  // Create manager object
  var object = new PIXI.Container();
  var _currentWinline = -1;
  var _previewTime = 2.5;
  var _lineWidth = 10.0;
  var _spotRadius = 5.0;
  var _fillScaler = 0.75;
  var _connectLineToPip = false;
  var _modalActive = false;

  object.winlineData = {};

  var generatePips = function (winlineData) {
    var winlineContainer = winlineData.winlineContainer;

    var global = reelManager.reels[0].toGlobal(new PIXI.Point(0, 0));
    var position = winlineData.winlineContainer.toLocal(global);

    var pipPositions = winlineData.pipPositions;
    var pipPositionsKeys = Object.keys(pipPositions);
    for (var i = 0; i < pipPositionsKeys.length; ++i) {
      var pipPos = pipPositions[pipPositionsKeys[i]];
      if (pipPos === undefined) {
        winlineData.winlinePipNumbers.push(undefined);
        continue;
      }

      pipPos.x += winlineData.pipSize / 2.0;
      pipPos.y += winlineData.pipSize / 2.0;

      var pip = undefined;
      if (winlineData.pipFileName !== undefined) {
        pip = resourceManager.createObject(
          "sprite",
          "pip" + winlineData.id + "_" + pipPositionsKeys[i],
          winlineContainer.name,
          {
            fileName: winlineData.pipFileName,
            position: pipPos,
            anchor: 0.5,
          }
        );
      } else {
        pip = new PIXI.Graphics();
        // pip.scale.set(resourceManager.selectedAssetResolution.scale);
        pip.lineStyle(
          winlineData.pipBorderSize,
          winlineData.pipBorderColour,
          1.0
        );
        pip.beginFill(winlineData.colour, 1.0);
        pip.drawCircle(pipPos.x, pipPos.y, winlineData.pipSize);
        pip.endFill();
        winlineContainer.addChild(pip);
      }

      pip.interactive = true;
      pip.mousedown = pip.touchstart = function () {
        object.previewWinline(this.id);
      }.bind(winlineData);

      winlineData.winlinePipGraphics.push(pip);

      if (winlineData.pipFont !== undefined) {
        var pipNumber = resourceManager.createObject(
          "text",
          "pip" + winlineData.id + "_" + pipPositionsKeys[i] + "number",
          winlineContainer.name,
          {
            text: (winlineData.id + 1).toString(),
            fontDefinition: winlineData.pipFont,
            anchor: 0.5,
          }
        );

        pipNumber.position.set(pipPos.x, pipPos.y);
        winlineData.winlinePipNumbers.push(pipNumber);
      }
    }

    object.addChild(winlineContainer);
  };
  var generateLine = function (winlineData) {
    var global = reelManager.reels[0].toGlobal(new PIXI.Point(0, 0));
    var position = winlineData.winlineContainer.toLocal(global);
    var offset = {
      x:
        (reelManager.reels[1].position.x - reelManager.reels[0].position.x) /
        reelManager.reels[0].scale.x,
      y:
        reelManager.reels[0].configParams.appertureSpacing *
        resourceManager.selectedAssetResolution.scale,
    };

    var linePositions = winlineData.lineData.spots;
    var lineGraphic = new PIXI.Graphics();
    // lineGraphic.scale.set(1, resourceManager.selectedAssetResolution.scale);
    addLine(
      lineGraphic,
      _lineWidth * resourceManager.selectedAssetResolution.scale,
      _spotRadius,
      winlineData.colour,
      position,
      offset,
      linePositions,
      winlineData.pipPositions
    );
    addLine(
      lineGraphic,
      _lineWidth * _fillScaler * resourceManager.selectedAssetResolution.scale,
      _spotRadius * _fillScaler,
      winlineData.fillColour,
      position,
      offset,
      linePositions,
      winlineData.pipPositions
    );

    winlineData.winLineGraphics.addChild(lineGraphic);
  };

  var addLine = function (
    lineGraphic,
    width,
    radius,
    colour,
    startPos,
    posOffset,
    linePositions,
    pipPositions
  ) {
    if (linePositions === undefined) return;
    // if line positions exist draw the line this check is nessisarry for when the game is loading and the line positions haven't loaded yet
    var spotPosition = {
      x: startPos.x + reelManager.reels[0].configParams.viewportWidth / 2.0,
      y: startPos.y + posOffset.y * (linePositions[0] + 0.5),
    };
    var nextSpotPosition = {};
    var startFrom = { x: 0, y: 0 };

    if (_connectLineToPip && pipPositions.left !== undefined) {
      startFrom.x = pipPositions.left.x;
      startFrom.y = pipPositions.left.y;
    } else {
      startFrom.x = startPos.x;
      startFrom.y = startPos.y + posOffset.y * (linePositions[0] + 0.5);
    }
    addLineSegment(lineGraphic, width, colour, startFrom, spotPosition);

    for (var i = 0; i < linePositions.length; ++i) {
      addSpot(lineGraphic, radius, colour, spotPosition);

      if (i < linePositions.length - 1) {
        nextSpotPosition = {
          x: startPos.x + posOffset.x * (i + 1.5),
          y: startPos.y + posOffset.y * (linePositions[i + 1] + 0.5),
        };

        addLineSegment(
          lineGraphic,
          width,
          colour,
          spotPosition,
          nextSpotPosition
        );
        spotPosition = nextSpotPosition;
      }
    }

    if (_connectLineToPip && pipPositions.right !== undefined) {
      nextSpotPosition = {
        x: pipPositions.right.x,
        y: pipPositions.right.y,
      };
    } else {
      nextSpotPosition = {
        x:
          spotPosition.x +
          reelManager.reels[0].configParams.viewportWidth / 2.0,
        y: spotPosition.y,
      };
    }

    addLineSegment(lineGraphic, width, colour, spotPosition, nextSpotPosition);
  };

  var addLineSegment = function (lineGraphic, width, colour, fromPos, toPos) {
    lineGraphic.lineStyle(width, colour, 1.0);
    lineGraphic.moveTo(fromPos.x, fromPos.y);
    lineGraphic.lineTo(toPos.x, toPos.y);
    lineGraphic.endFill();
  };

  var addSpot = function (lineGraphic, radius, colour, pos) {
    lineGraphic.beginFill(colour, 1.0);
    lineGraphic.lineStyle(0, 0, 0);
    lineGraphic.drawCircle(pos.x, pos.y, radius);
    lineGraphic.endFill();
  };

  object.parseGameConfig = function (gameConfigTask) {
    var winlines = gameConfigTask.data.slotConfig.paylines;
    var keys = Object.keys(this.winlineData);
    for (var i = 0; i < keys.length; ++i) {
      var winlineData = this.winlineData[keys[i]];
      winlineData.lineData = winlines[winlineData.id];
      generatePips(winlineData);
      generateLine(winlineData);
    }

    this.hideAllWinlines();
  };

  object.setParams = function (json) {
    _previewTime =
      json.previewTime !== undefined ? json.previewTime : _previewTime;
    _lineWidth = json.lineWidth !== undefined ? json.lineWidth : _lineWidth;
    _spotRadius = json.spotRadius !== undefined ? json.spotRadius : _spotRadius;
    _fillScaler = json.fillScaler !== undefined ? json.fillScaler : _fillScaler;
    _connectLineToPip =
      json.connectLineToPip !== undefined
        ? json.connectLineToPip
        : _connectLineToPip;
  };

  object.previewWinline = function (index) {
    if (!_modalActive) {
      this.winlineData[index].currentPreviewTime = 0;
      this.winlineData[index].winLineGraphics.visible = true;
    }
  };

  object.showWinline = function (index) {
    this.winlineData[index].currentPreviewTime = -1;
    this.winlineData[index].winLineGraphics.visible = true;
  };

  object.hideWinline = function (index) {
    this.winlineData[index].currentPreviewTime = _previewTime + 1;
  };

  object.hideAllWinlines = function () {
    var keys = Object.keys(this.winlineData);
    for (var i = 0; i < keys.length; ++i) {
      this.winlineData[keys[i]].currentPreviewTime = _previewTime + 1;
    }
  };

  object.update = function (delta) {
    var keys = Object.keys(this.winlineData);
    for (var i = 0; i < keys.length; ++i) {
      var data = this.winlineData[keys[i]];
      if (
        data.winLineGraphics.visible === true &&
        data.currentPreviewTime > -1
      ) {
        data.currentPreviewTime += delta / 1000;
        if (data.currentPreviewTime > _previewTime) {
          data.winLineGraphics.visible = false;
        }
      }
    }
  };

  object.onOrientationChange = function () {
    if (!this.winlineData[0].lineData || this.winlineData[0].length === 0)
      return;
    var keys = Object.keys(this.winlineData);
    for (var i = 0; i < keys.length; ++i) {
      var winlineData = this.winlineData[keys[i]];

      if (winlineData.pipFont !== undefined) {
        var pipPositions = winlineData.pipPositions;
        var pipPositionsKeys = Object.keys(pipPositions);
        for (var j = 0; j < pipPositionsKeys.length; ++j) {
          var pipPos = pipPositions[pipPositionsKeys[j]];
          if (pipPos === undefined) {
            continue;
          }
          winlineData.winlinePipNumbers[j].position.set(pipPos.x, pipPos.y);
        }
      }

      resourceManager.destroyObject(winlineData.winLineGraphics.name);
      winlineData.winLineGraphics = resourceManager.createObject(
        "container",
        "graphics",
        winlineData.winlineContainer.name,
        {}
      );

      generateLine(winlineData);
    }
  };

  object.modal = function (data) {
    _modalActive = data.reason !== undefined;
    if (_modalActive) {
      this.hideAllWinlines();
    }
  };

  Object.defineProperty(object, "currentWinline", {
    get: function () {
      return _currentWinline;
    },
  });
  Object.defineProperty(object, "previewTime", {
    get: function () {
      return _previewTime;
    },
    set: function (time) {
      _previewTime = time;
    },
  });
  Object.defineProperty(object, "currentPreviewTime", {
    get: function () {
      return _currentPreviewTime;
    },
  });

  messageBus.subscribe(
    "spinner:GameConfigEvent",
    object.parseGameConfig.bind(object)
  );
  messageBus.subscribe("game:modal", object.modal.bind(object));

  Reflex.addToUpdate(object.update.bind(object));
  Reflex.registerEventHandler(
    "orientationChange",
    object.onOrientationChange.bind(object)
  );

  return object;
};

winlineManager.initialise = function (json, object) {
  //Load json values
  object.setParams(json);

  var winlineData = json.winlineData;
  for (var i = 0; i < winlineData.length; ++i) {
    var data = new winlineManager.winlineData(winlineData[i], object.name);
    object.winlineData[data.id] = data;
  }

  object.hideAllWinlines();
};

winlineManager.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "winlineManager",
  winlineManager.create,
  winlineManager.initialise,
  winlineManager.getFilesRequired
);
